import i18n from '@/plugins/vue-i18n'
export default {
  namespaced: true,
  state: {
  },
  actions: {
  },
  getters: {
    getAll () {
      return [
        {
          codigo: 'VD_PBC',
          descripcion: i18n.t('store.rolPbc')
        },
        {
          codigo: 'VD_COMERCIAL',
          descripcion: i18n.t('store.rolComercial')
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/maestros/roles/store.js